<template>
  <div class="agentgrid-illustration">
    <img src="@/assets/illustrations/auth/agentgrid-panel.jpg" class="agentgrid-panel" alt="" />
  </div>
</template>

<script>
export default {
  name: 'AgentGridIllustration'
};
</script>

<style lang="scss" scoped>
.agentgrid-illustration {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: var(--agentgrid-background-surface);
}

.agentgrid-panel {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
</style>
